module.exports = __webpack_public_path__ + "img/ic-100-retorno.8bdd90de.svg";